export const assetManagerServiceMessages = {
  STATUS: {
    GET_ERROR: 'Unable to check Asset Manager access',
  },
  LIST_CONFIG: {
    SAVE_SUCCESS: 'Asset list updated',
    SAVE_ERROR: 'Unable to update the asset list',
    LOAD_ERROR: 'Unable to load the asset list',
    LAYERS_ERROR: 'Unable to load asset map layers',
    FIELDS_ERROR: 'Unable to load layer fields',
    KEY_FIELD_ERROR: 'Unable to set the key field',
  },
  ASSETS: {
    GET_DETAILS_ERROR: 'Unable to load asset details',
  },
  STATISTICS: {
    GET_ERROR: 'Unable to load asset statistics',
    CREATE_SUCCESS: 'Statistic added',
    CREATE_ERROR: 'Unable to add the statistic',
    UPDATE_SUCCESS: 'Statistic updated',
    UPDATE_ERROR: 'Unable to update the statistic',
    DELETE_SUCCESS: 'Statistic removed',
    DELETE_ERROR: 'Unable to remove the statistic',
    FIELD_VALUES_ERROR: 'Unable to load field values',
  },
};
